var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{attrs:{"colour":_vm.colour,"background-colour":_vm.backgroundColour,"icon":_vm.icon,"icon-colour":_vm.iconColour,"block":_vm.block},on:{"click":_vm.clicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }